(function () {
  'use strict';

  if (window.__ps5youc) return;
  window.__ps5youc = {};

  function fmt(n) {
    const s = n.toString();
    const last3 = s.slice(-3);
    const rest = s.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',');
    return rest ? rest + ',' + last3 : last3;
  }

  function countUp(el) {
    const target = parseInt(el.dataset.count, 10);
    if (Number.isNaN(target)) return;
    const dur = 1800;
    const t0 = performance.now();
    (function step(now) {
      const p = Math.min((now - t0) / dur, 1);
      const v = Math.floor((1 - Math.pow(1 - p, 3)) * target);
      el.textContent = fmt(v);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = fmt(target);
    })(t0);
  }

  window.__ps5youc.fmt = fmt;

  window.__ps5youc.reveal = function (root) {
    const scope = root || document;
    const revObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          revObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -36px 0px' });
    scope.querySelectorAll('.ps5youc-reveal').forEach(function (el) {
      revObs.observe(el);
    });

    const cntObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.target.dataset.count) {
          countUp(e.target);
          cntObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    scope.querySelectorAll('[data-count]').forEach(function (el) {
      cntObs.observe(el);
    });

    scope.querySelectorAll('.ps5youc-recipes__grid .ps5youc-recipes__tile').forEach(function (el, i) {
      el.style.transitionDelay = (i % 5) * 70 + 'ms';
    });
    scope.querySelectorAll('.ps5youc-growth__grid .ps5youc-growth__card').forEach(function (el, i) {
      el.style.transitionDelay = i * 90 + 'ms';
    });
    scope.querySelectorAll('.ps5youc-reviews__grid .ps5youc-reviews__card').forEach(function (el, i) {
      el.style.transitionDelay = i * 80 + 'ms';
    });
    scope.querySelectorAll('.ps5youc-videos__card').forEach(function (el, i) {
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
    });
    scope.querySelectorAll('.ps5youc-stats__grid .ps5youc-stats__card').forEach(function (el, i) {
      el.style.transitionDelay = i * 100 + 'ms';
    });
  };

  function getStickyHeaderHeight() {
    var header =
      document.querySelector('sticky-header') ||
      document.querySelector('.shopify-section-header-sticky') ||
      document.querySelector('.header-wrapper');
    if (!header) return 56;
    return header.getBoundingClientRect().height || 56;
  }

  window.__ps5youc.scrollToHash = function (hash) {
    var id = (hash || '').replace(/^#/, '');
    if (!id) return false;

    var anchor = document.getElementById(id);
    if (!anchor) return false;

    var section = anchor.closest('.shopify-section') || anchor;
    var headerH = getStickyHeaderHeight();
    var gap = 16;
    var rect = section.getBoundingClientRect();
    var sectionTop = window.scrollY + rect.top;
    var sectionH = section.offsetHeight;
    var usable = window.innerHeight - headerH - gap * 2;
    var targetY;

    if (sectionH <= usable) {
      targetY = sectionTop - headerH - gap - (usable - sectionH) / 2;
    } else {
      targetY = sectionTop - headerH - gap;
    }

    var prefersReduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: Math.max(0, targetY),
      behavior: prefersReduced ? 'auto' : 'smooth'
    });

    if (history && history.pushState) {
      history.pushState(null, '', '#' + id);
    }

    return true;
  };

  window.__ps5youc.initInPageScroll = function () {
    if (window.__ps5youc.scrollInit) return;
    window.__ps5youc.scrollInit = true;

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('a[href^="#"]');
        if (!link || !link.classList.contains('ps5youc-hero__cta')) return;

        var href = link.getAttribute('href') || '';
        if (!href || href === '#') return;
        if (!document.getElementById(href.slice(1))) return;

        event.preventDefault();
        window.__ps5youc.scrollToHash(href);
      },
      true
    );

    if (window.location.hash) {
      window.requestAnimationFrame(function () {
        window.__ps5youc.scrollToHash(window.location.hash);
      });
    }
  };

  window.__ps5youc.initPressCarousel = function (root) {
    if (!root || root.dataset.pressInit) return;
    if (root.hasAttribute('data-autoscroll-off')) return;

    var scroll = root.querySelector('.ps5youc-press__scroll');
    var cards = scroll ? scroll.querySelectorAll('.press-card') : [];
    if (!scroll || cards.length < 2) return;

    root.dataset.pressInit = 'true';

    var index = 0;
    var paused = false;
    var interval = parseInt(root.dataset.autoscrollMs || '5000', 10);
    if (Number.isNaN(interval) || interval < 1000) interval = 5000;

    function scrollToIndex(i) {
      var card = cards[i];
      if (!card) return;
      scroll.scrollTo({ left: card.offsetLeft - scroll.offsetLeft, behavior: 'smooth' });
    }

    scroll.addEventListener('mouseenter', function () { paused = true; });
    scroll.addEventListener('mouseleave', function () { paused = false; });
    scroll.addEventListener('focusin', function () { paused = true; });
    scroll.addEventListener('focusout', function () { paused = false; });
    scroll.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    scroll.addEventListener('touchend', function () { paused = false; }, { passive: true });
    scroll.addEventListener('scroll', function () {
      var mid = scroll.scrollLeft + scroll.clientWidth * 0.35;
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        if (card.offsetLeft <= mid && card.offsetLeft + card.offsetWidth > mid) {
          index = i;
          break;
        }
      }
    }, { passive: true });

    window.setInterval(function () {
      if (paused) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      index = (index + 1) % cards.length;
      scrollToIndex(index);
    }, interval);
  };

  window.__ps5youc.loadShared = function () {
    if (window.__ps5youc.sharedLoaded) return;
    window.__ps5youc.sharedLoaded = true;
    window.__ps5youc.reveal(document);
    window.__ps5youc.initInPageScroll();
  };
})();
